import {
  Component,
  AfterViewInit,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { format } from 'date-fns';
import { OportunidadesService } from '../../services/oportunidadesComercialesExternos/oportunidades.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChangeDetectorRef } from '@angular/core';
import { StorageService } from '../../utils/util.storage.service';
import { Router } from '@angular/router';
import { UserLoggedResponse } from '../../models/user';
import { DialogOporunidadesExternosComponent } from '../common/dialogs/dialog-oporunidades-externos/dialog-oporunidades-externos.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-mis-oportunidades-comerciales-asesor-externo',
  templateUrl: './mis-oportunidades-comerciales-asesor-externo.component.html',
  styleUrls: ['./mis-oportunidades-comerciales-asesor-externo.component.css'],
})
export class MisOportunidadesComercialesAsesorExternoComponent implements OnInit {
  hoveringBitacora = false;

  frmOportunidadesComerciales: FormGroup;

  @ViewChild('cambioEstadoDialog') cambioEstadoDialog!: TemplateRef<any>;
  @ViewChild('bitacoraDialog') bitacoraDialog!: TemplateRef<any>;

  estadoTemporalSeleccionado = '';
  observacionesEstado = '';
  mostrarObservacion = false;
  oportunidadSeleccionada: any = null;
  estadoCambioExitoso = false;
  mensajeExitoCambio = '';
  opcionesCambioEstado: string[] = [];
  resumenEstados: { estado: string; cantidad: number }[] = [];

  documentTypeData = [
    { acronym: 'BG', name: 'BEBÉ GESTANTE' },
    { acronym: 'CC', name: 'CÉDULA DE CIUDADANÍA' },
    { acronym: 'CE', name: 'CÉDULA DE EXTRANJERÍA' },
    { acronym: 'CN', name: 'NACIDO VIVO' },
    { acronym: 'PA', name: 'PASAPORTE' },
    { acronym: 'PE', name: 'PERMISO ESPECIAL DE PERMANENCIA' },
    { acronym: 'PT', name: 'PERMISO POR PROTECCIÓN TEMPORAL' },
    { acronym: 'RC', name: 'REGISTRO CIVIL DE NACIMIENTO' },
    { acronym: 'TI', name: 'TARJETA DE IDENTIDAD' },
  ];

  estadoData = [
    { value: 'registrada', label: 'Registrada' },
    { value: 'ACERCAMIENTO Y CITA', label: 'Acercamiento y cita' },
    {
      value: 'DIAGNÓSTICO DE NECESIDADES',
      label: 'Diagnóstico de necesidades',
    },
    {
      value: 'PRESENTACIÓN DE LA OFERTA Y SEGUIMIENTO',
      label: 'Presentación de la oferta y seguimiento',
    },
    { value: 'CERRADA PERDIDA', label: 'Cerrada perdida' },
    { value: 'CERRADA GANADA', label: 'Cerrada ganada' },
  ];

  numeroIdentificacionData: string[] = [];
  userData: any[] = [];
  bitacoraSeleccionada: any[] = [];
  logInfo: any;

  displayedColumns: string[] = [
    'fechaCreacion',
    'tipoIdentificacion',
    'numeroIdentificacion',
    'nombreApellido',
    'campania',
    'lineaNegocio',
    'observaciones',
    'celular',
    'correo',
    'estado',
    'fechaUltimaGestion',
    'cumplimiento',
    'acciones',
  ];

  estadoSecuencial: { [key: string]: string[] } = {
    registrada: [
      'Acercamiento y cita',
      'Diagnóstico de necesidades',
      'Presentación de la oferta y seguimiento',
      'Cerrada perdida',
      'Cerrada ganada',
    ],
    'acercamiento y cita': [
      'Diagnóstico de necesidades',
      'Presentación de la oferta y seguimiento',
      'Cerrada perdida',
      'Cerrada ganada',
    ],
    'diagnóstico de necesidades': [
      'Presentación de la oferta y seguimiento',
      'Cerrada perdida',
      'Cerrada ganada',
    ],
    'presentación de la oferta y seguimiento': [
      'Cerrada perdida',
      'Cerrada ganada',
    ],
  };

  estadoDialogRef!: MatDialogRef<any>;
  reglasSemaforo: any[] = [];
  generalMessage: string = '';
  haveDataToShow: boolean = false;
  dataSource = new MatTableDataSource<any>();

  constructor(
    private mainCmp: MaincontainerComponent,
    private fb: FormBuilder,
    private oportunidadesService: OportunidadesService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private matDialog: MatDialog,
    public router: Router
  ) {
    this.frmOportunidadesComerciales = this.fb.group({
      tipo: [''],
      numero: [''],
      estado: [''],
      fecha_inicio: [''],
      fecha_ultima: [''],
    });
  }

  private paginatorInterno!: MatPaginator;

  @ViewChild(MatPaginator)
  set paginator(paginator: MatPaginator) {
    if (paginator) {
      this.paginatorInterno = paginator;
      this.dataSource.paginator = paginator;
    }
  }

  @ViewChild(MatSort)
  set matSort(sort: MatSort) {
    if (sort) {
      this.dataSource.sort = sort;
    }
  }

  async ngOnInit(): Promise<void> {
    this.mainCmp.setTitle('CONSULTA MIS OPORTUNIDADES COMERCIALES');

    this.configurarOrdenamiento();

    const userCC: UserLoggedResponse = this.storageService.getItem('user');
    const cedulaAsesor =
      userCC?.document?.split('. ')[1] || userCC?.document || '';


    const filtros = {
      id: null,
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      estado: '',
      fechaInicio: '',
      fechaUltima: '',
      codigoAsesor: '',
    };

    this.spinner.show();

    // Usamos subscribe para obtener el código del asesor (number | null)
    this.oportunidadesService.obtenerCodigoAsesor(cedulaAsesor).subscribe({
      next: (codigoAsesor: number | null) => {
        if (!codigoAsesor) {
          console.warn(
            'No se encontró código de asesor para la cédula',
            cedulaAsesor
          );
          this.spinner.hide();
          alert('No se encontró código para el asesor');
          return;
        }

        // Construir el request con codigoAsesor
        const request = {
          id: filtros.id,
          tipoIdentificacion: filtros.tipoIdentificacion,
          numeroIdentificacion: filtros.numeroIdentificacion,
          estado: filtros.estado,
          fechaInicio: filtros.fechaInicio,
          fechaUltima: filtros.fechaUltima,
          codigoAsesor: codigoAsesor.toString(),
        };

        // Obtener oportunidades filtradas usando el request
        this.oportunidadesService.consultar(request).subscribe({
          next: (response) => {
            const records = response;

            // Obtener el HTML del modal
            this.oportunidadesService.mostrarMensajeModal().subscribe({
              next: (modalResp) => {
                this.spinner.hide();

                const templateHtml = modalResp?.data?.content?.template || '';

                // Extraer estados del HTML
                const estadoRegex = /<div[^>]*>\s*([^–<]+)\s*–\s*XX\s*<\/div>/g;
                let estadosExtraidos: string[] = [];
                let match;
                while ((match = estadoRegex.exec(templateHtml)) !== null) {
                  estadosExtraidos.push(match[1].trim().toUpperCase());
                }

                // Inicializar conteo con estados extraidos en 0
                const conteo: Record<string, number> = {};
                estadosExtraidos.forEach((e) => (conteo[e] = 0));

                // Contar oportunidades por estado basado en estados extraidos
                records.forEach((op: any) => {
                  const estado = (op.estado || 'SIN ESTADO').toUpperCase();
                  if (conteo.hasOwnProperty(estado)) {
                    conteo[estado] += 1;
                  }
                });

                // Abrir modal con conteo y html
                const dialogRef = this.matDialog.open(
                  DialogOporunidadesExternosComponent,
                  {
                    width: '600px',
                    data: {
                      conteo,
                      template: templateHtml,
                    },
                  }
                );

                dialogRef.afterClosed().subscribe(() => {});
              },
              error: (err) => {
                this.spinner.hide();
                console.error('Error al obtener mensaje modal:', err);
                alert('Error al obtener mensaje del modal');
              },
            });
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Error al obtener oportunidades:', err);
            alert('Error al obtener oportunidades');
          },
        });
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al obtener código del asesor:', err);
        alert('Error al obtener código del asesor');
      },
    });

    this.consultarReglasDeSemaforizacion();
    this.logInfo = this.storageService.getItem('user');
  }

  private configurarOrdenamiento(): void {
    const columnasPermitidas = [
      'fechaCreacion',
      'numeroIdentificacion',
      'estado',
      'fechaUltimaGestion',
    ];

    const columnasFecha = [
      'fechaCreacion',
      'fechaUltimaGestion',
    ];

    this.dataSource.sortingDataAccessor = (
      item: any,
      property: string,
    ): string | number => {
      if (!columnasPermitidas.includes(property)) {
        return '';
      }

      const value = item[property];

      if (value === null || value === undefined || value === '') {
        return '';
      }

      if (columnasFecha.includes(property)) {
        const fecha = new Date(value);

        return Number.isNaN(fecha.getTime())
          ? 0
          : fecha.getTime();
      }

      if (property === 'numeroIdentificacion') {
        const numero = Number(value);

        return Number.isNaN(numero)
          ? 0
          : numero;
      }

      return String(value)
        .trim()
        .toLocaleLowerCase('es-CO');
    };
  }

  consultarReglasDeSemaforizacion(): void {
    this.oportunidadesService.consultarReglasDeSemaforizacion().subscribe({
      next: (resp) => {
        this.reglasSemaforo = resp.data?.content || [];
      },
      error: (err) => console.error('Error cargando reglas', err),
    });
  }

  evaluarCondicion(regla: any, dias: number): boolean {
    const condicion = (regla.conditionName || '').toLowerCase();
    switch (condicion) {
      case 'menor o igual que':
        return dias <= regla.rangeMin;
      case 'mayor o igual que':
        return dias >= regla.rangeMin;
      case 'igual a':
        return dias === regla.rangeMin;
      case 'entre':
        return dias >= regla.rangeMin && dias <= regla.rangeMax;
      default:
        return false;
    }
  }

  get getControl() {
    return this.frmOportunidadesComerciales.controls;
  }

  hasError(control: AbstractControl | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  printError(
    control: AbstractControl | null,
    messages: { [key: string]: string }
  ): string {
    if (!control || !control.errors) return '';
    const errorKey = Object.keys(control.errors)[0];
    return messages[errorKey] || 'Error';
  }

  disableArrowKeys(event: KeyboardEvent): void {
    if (['ArrowUp', 'ArrowDown'].includes(event.key)) {
      event.preventDefault();
    }
  }

  limpiarFormulario(): void {
    this.frmOportunidadesComerciales.reset();
    this.userData = [];
    this.dataSource.data = [];
    this.numeroIdentificacionData = [];

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  onTipoIdentificacionChange(): void {
    const tipo = this.frmOportunidadesComerciales.get('tipo')?.value;

    if (tipo) {
      this.oportunidadesService
        .obtenerNumerosIdentificacionPorTipo(tipo)
        .subscribe({
          next: (data: string[]) => {
            this.numeroIdentificacionData = data;
            this.frmOportunidadesComerciales.get('numero')?.reset();
          },
          error: (err) => {
            console.error('Error al obtener números:', err);
            this.numeroIdentificacionData = [];
          },
        });
    } else {
      this.numeroIdentificacionData = [];
    }
  }

  consultarOportunidades(): void {
    if (this.frmOportunidadesComerciales.invalid) {
      this.haveDataToShow = false;
      this.frmOportunidadesComerciales.markAllAsTouched();
      return;
    }

    const form = this.frmOportunidadesComerciales.value;

    // Obtener cédula desde storage
    this.logInfo = this.storageService.getItem('user');
    const documento = this.logInfo?.document || '';
    const cedula = documento.split(' ').pop() || '';

    this.spinner.show();

    // 1️⃣ Obtener código de asesor
    this.oportunidadesService.obtenerCodigoAsesor(cedula).subscribe({
      next: (codigoAsesor: number | null) => {
        if (!codigoAsesor) {
          console.warn(
            'No se encontró código de asesor para la cédula',
            cedula
          );
          this.userData = [];
          this.spinner.hide();
          return;
        }

        const filtros = {
          id: form.id,
          tipoIdentificacion: form.tipo?.trim() || '',
          numeroIdentificacion: form.numero?.trim() || '',
          estado: form.estado?.trim() || '',
          fechaCreacion: form.fecha_inicio
            ? format(form.fecha_inicio, 'yyyy-MM-dd')
            : null,
          codigoAsesor: String(codigoAsesor),
        };

        this.oportunidadesService.consultarReglasDeSemaforizacion().subscribe({
          next: (resp) => {
            this.reglasSemaforo = resp.data?.content || [];

            // Consultar oportunidades (backend ya filtra por fechaCreacion)
            this.oportunidadesService.consultar(filtros).subscribe({
              next: (data: any[]) => {

                // 🔎 Filtro SOLO por fechaUltimaGestion en FRONT
                const formattedHasta = form.fecha_ultima
                  ? format(form.fecha_ultima, 'yyyy-MM-dd')
                  : null;

                const dataFiltrada = data.filter((item) => {
                  if (!formattedHasta) return true; // Si no hay filtro -> devolver todo

                  const itemFechaUltima = item.fechaUltimaGestion
                    ? String(item.fechaUltimaGestion).split('T')[0] // YYYY-MM-DD
                    : null;

                  // ✅ FILTRAR SOLO COINCIDENCIA EXACTA
                  return (
                    itemFechaUltima !== null &&
                    itemFechaUltima === formattedHasta
                  );
                });

                // 🔄 Asignar data con cálculo de semáforo
                const oportunidadesProcesadas = dataFiltrada.map((oportunidad) => {
                  const estado = oportunidad.estado || '';
                  let diasDiferencia = 0;

                  if (estado.toLowerCase() === 'registrada') {
                    const fechaCreacion = oportunidad.fechaCreacion
                      ? new Date(oportunidad.fechaCreacion)
                      : null;
                    diasDiferencia = fechaCreacion
                      ? Math.floor(
                          (new Date().getTime() - fechaCreacion.getTime()) /
                            (1000 * 3600 * 24)
                        )
                      : 0;
                  } else if (
                    estado.toLowerCase() !== 'cerrada ganada' &&
                    estado.toLowerCase() !== 'cerrada perdida'
                  ) {
                    const fechaUltima = oportunidad.fechaUltimaGestion
                      ? new Date(oportunidad.fechaUltimaGestion)
                      : null;
                    diasDiferencia = fechaUltima
                      ? Math.floor(
                          (new Date().getTime() - fechaUltima.getTime()) /
                            (1000 * 3600 * 24)
                        )
                      : 0;
                  }

                  const normalizar = (txt: string) =>
                    (txt || '').trim().toLowerCase();

                  const estadoNormalizado = normalizar(estado);
                  const regla = this.reglasSemaforo.find(
                    (r) =>
                      normalizar(r.statusName) === estadoNormalizado &&
                      this.evaluarCondicion(r, diasDiferencia) &&
                      r.active
                  );

                  let color = '';
                  if (regla) {
                    color = regla.colorName.toLowerCase();
                  } else if (estado.toLowerCase() === 'cerrada ganada') {
                    color = 'verde';
                  } else if (estado.toLowerCase() === 'cerrada perdida') {
                    color = 'negro';
                  }

                  return { ...oportunidad, colorSemaforo: color };
                });

                oportunidadesProcesadas.sort((a: any, b: any) => {
                  const fechaA = a.fechaCreacion
                    ? new Date(a.fechaCreacion).getTime()
                    : 0;

                  const fechaB = b.fechaCreacion
                    ? new Date(b.fechaCreacion).getTime()
                    : 0;

                  return fechaB - fechaA;
                });

                this.userData = oportunidadesProcesadas;
                this.dataSource.data = oportunidadesProcesadas;

                if (this.paginator) {
                  this.paginator.firstPage();
                }

                this.spinner.hide();
              },
              error: (err) => {
                this.userData = [];
                this.spinner.hide();
              },
            });
          },
          error: (err) => {
            console.error('Error cargando reglas de semaforización', err);
            this.spinner.hide();
          },
        });
      },
      error: (err) => {
        console.error('Error obteniendo código de asesor:', err);
        this.userData = [];
        this.spinner.hide();
      },
    });
  }

  abrirBitacora(oportunidad: any): void {
    this.oportunidadesService
      .obtenerBitacora(oportunidad.numeroIdentificacion)
      .subscribe({
        next: (data: any[]) => {
          // Ordenamos por fecha descendente (más reciente primero)
          this.bitacoraSeleccionada = data.sort(
            (a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime()
          );

          this.dialog.open(this.bitacoraDialog, {
            width: '600px',
            maxHeight: '80vh',
            disableClose: true,
          });
        },
        error: (err) => {
          console.error('Error al obtener bitácora:', err);
          alert('No se pudo cargar la bitácora');
          this.bitacoraSeleccionada = [];
        },
      });
  }

  abrirCambiarEstado(oportunidad: any): void {
    this.oportunidadSeleccionada = oportunidad;

    const estadoActual = (oportunidad.estado || '').trim().toLowerCase();

    this.opcionesCambioEstado = this.estadoSecuencial[estadoActual] || [];
    this.estadoTemporalSeleccionado = '';
    this.observacionesEstado = '';
    this.mostrarObservacion = false;
    this.estadoCambioExitoso = false;

    this.estadoDialogRef = this.dialog.open(this.cambioEstadoDialog, {
      width: '500px',
      disableClose: true,
    }) as MatDialogRef<any>;
  }

  continuarCambioEstado(): void {
    if (!this.estadoTemporalSeleccionado) {
      alert('Seleccione un estado antes de continuar');
      return;
    }
    this.mostrarObservacion = true;
  }

  finalizarCambioEstado(): void {
    const userCC = this.storageService.getItem('user');
    const nombreCompleto = `${userCC?.nombre || ''} ${
      userCC?.primerApellido || ''
    } ${userCC?.segundoApellido || ''}`.trim();

    const dto = {
      id: this.oportunidadSeleccionada.id,
      numeroIdentificacion: this.oportunidadSeleccionada.numeroIdentificacion,
      nuevoEstado: this.estadoTemporalSeleccionado,
      observaciones: this.observacionesEstado,
      usuario: nombreCompleto,
    };

    this.oportunidadesService.finalizar(dto).subscribe({
      next: () => {
        this.mensajeExitoCambio = 'El estado se ha modificado correctamente.';
        this.estadoCambioExitoso = true;

        const index = this.userData.findIndex(
          (o: any) => o.id == this.oportunidadSeleccionada.id
        );

        if (index !== -1) {
          const nuevoEstado = this.estadoTemporalSeleccionado;
          let color = this.userData[index].colorSemaro;

          if (nuevoEstado.toLowerCase() === 'cerrada ganada') {
            color = 'verde';
          } else if (nuevoEstado.toLowerCase() === 'cerrada perdida') {
            color = 'negro';
          }

          // Actualizar localmente
          this.userData[index] = {
            ...this.userData[index],
            estado: nuevoEstado,
            fechaUltimaGestion: new Date().toISOString().split('T')[0],
            colorSemaforo: color,
          };

          // 🔹 Forzar refresco en Angular
          this.userData = [...this.userData];
        }

        this.cerrarDialogoEstado();
      },
      error: (err) => {
        console.error('Error al actualizar estado:', err);
        alert('Hubo un error al actualizar el estado');
      },
    });
  }

  cerrarDialogoEstado(): void {
    this.estadoDialogRef?.close();
    this.estadoCambioExitoso = false;
    this.mostrarObservacion = false;
    this.mensajeExitoCambio = '';
  }
}
